import { useState } from 'react';

const useCustomReplies = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const createCustomReply = async (replyData) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/custom-replies`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(replyData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create custom reply');
      }

      setIsLoading(false);
      return { success: true, data };
    } catch (err) {
      setIsLoading(false);
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  return { createCustomReply, isLoading, error };
};

export default useCustomReplies;